import { listenFlowDemo } from "~/components/marketing/demo";
import { ListenFlowMockup } from "~/components/marketing/mockups";
import { Eyebrow, SectionTitle } from "~/components/marketing/ui";
import { useI18n } from "~/i18n";

export const HowItWorks = () => {
  const { t } = useI18n();
  return (
    <section aria-labelledby="home-how" class="px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
      <div class="mx-auto max-w-7xl">
        <Eyebrow index="01" label={t("marketing.home.how.eyebrow")} id="home-how" />
        <SectionTitle id="home-how" text={t("marketing.home.how.title")} compact class="mt-3" />
        <div class="mt-8">
          <ListenFlowMockup data={listenFlowDemo(t)} />
        </div>
      </div>
    </section>
  );
};
